import React, { useEffect, useReducer } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import reducer, { defaultState, setEditDataCreator, updateFieldCreator } from './reducer';
import {
  updateMaTrainingCreator,
  setMaTrainingsEditErrorsCreator,
} from '../../../../../store/actionsCreators';
import EditTraining from '../../../../../shared/Cpd/Trainings/Edit/EditTraining';

const EditMaTraining = ({ training, errors, updateTraining, removeError }) => {
  const [state, dispatch] = useReducer(reducer, defaultState);

  useEffect(() => {
    if (training && training.id) {
      dispatch(setEditDataCreator(training));
    }
  }, [training]);

  return (
    <EditTraining
      state={state}
      dispatch={dispatch}
      updateFieldCreator={updateFieldCreator}
      errors={errors}
      updateTraining={updateTraining}
      removeError={removeError}
    />
  );
};

EditMaTraining.propTypes = {
  training: PropTypes.object,
  errors: PropTypes.object,
  updateTraining: PropTypes.func.isRequired,
  removeError: PropTypes.func.isRequired,
};

EditMaTraining.defaultProps = {
  errors: {},
  training: {},
};

const mapStateToProps = ({ ma }) => ({
  errors: ma.trainings.editErrors,
  training: ma.trainings.profile,
});

const mapDispatchToProps = (dispatch) => ({
  updateTraining: (id, payload, history) =>
    dispatch(updateMaTrainingCreator(id, payload, history)),
  removeError: (payload) => dispatch(setMaTrainingsEditErrorsCreator(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditMaTraining);
